import axios from 'axios';

const api = axios.create({
  baseURL: '/api', // Mude para a URL real do seu backend se necessário
});

export default api;